import { api } from '../../../shared/services/api/client';

export const getMe = () => api.get('/auth/me');
export const verifyInvite = (token) => api.get('/auth/verify-invite', { params: { token } });
export const acceptInvite = (token, password) => api.post('/auth/accept-invite', { token, password });
